import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
export function CTASection() {
  const scrollToPricing = () => {
    // Scroll to the top where the pricing section is
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 md:px-8 max-w-4xl mx-auto text-center" data-id="element-34">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="bg-surface border border-primary/30 rounded-3xl p-8 md:p-12 glow-border relative overflow-hidden" data-id="element-35">
        <div className="absolute inset-0 bg-primary/5 blur-3xl rounded-full" data-id="element-36"></div>

        <div className="relative z-10" data-id="element-37">
          <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight mb-6 text-white" data-id="element-38">
            ¿LISTO PARA LLEVAR TUS VIDEOS AL{' '}
            <span className="text-primary" data-id="element-39">SIGUIENTE NIVEL?</span>
          </h2>
          <p className="text-textSecondary text-lg mb-8 max-w-2xl mx-auto" data-id="element-40">
            Únete a miles de creadores que ya están ahorrando horas de edición y
            logrando resultados profesionales.
          </p>

          <button onClick={scrollToPricing} className="w-full md:w-auto px-12 py-5 bg-primary hover:bg-primary/90 text-white font-black text-xl uppercase tracking-widest rounded-xl transition-all duration-300 transform hover:scale-105 shadow-[0_0_30px_rgba(59,130,246,0.5)] hover:shadow-[0_0_40px_rgba(59,130,246,0.7)] flex items-center justify-center mx-auto" data-id="element-41">
            <ShoppingCart className="w-6 h-6 mr-3" data-id="element-42" />
            ¡QUIERO EL PACK!
          </button>
        </div>
      </motion.div>
    </section>;
}